import { JSX } from "react";
import { preventDefaultMouseEvent } from "../shared/utility";
import { ProviderSetSimpleModel } from "./providerSet";

export default function ProviderSetIconBox(providerSet: ProviderSetSimpleModel): JSX.Element {
  return (
    <div data-animation-effect="fadeInUpSmall" data-effect-delay="0">
      <div className="body">
        <div className="row w-100">
          <div className="color-caribbean-green">
            <span className="icon-container col-md-12 color-caribbean-green">
              <i className={providerSet.sourceProviderSetId ? "fa fa-filter" : "fa fa-user-md"} />
            </span>
            <a className="apply-tooltip" href="#" data-toggle="tooltip" data-placement="top" title={providerSet.name} onClick={preventDefaultMouseEvent}>
              {providerSet.name}
            </a>
          </div>
        </div>
      </div>
    </div>);
}
